import styled from 'styled-components';
import { Flex, Box } from 'reflexbox/styled-components';
import Image from 'next/image';

import Section from '@/components/section';
import TitleBase from '@/components/title';
import SubTitleBase from '@/components/sub-title';
import ParagraphBase from '@/components/paragraph';

const Title = styled(TitleBase)`
  color: ${props => props.theme.colors.brand.primary};
  font-weight: 600;
  margin: 0 0 .5em;
`;

const SubTitle = styled(SubTitleBase)`
  font-style: italic;
`;

const Paragraph = styled(ParagraphBase)`
  margin: 1.5em 0;
`;

const RightColumn = styled(Box)`
  > div, img {
    border-radius: 1vw;
    box-shadow: ${props => props.theme.shadows.hover};
  }
`;

const Openings = () => {
  return (
    <Section>
      <Title maxSize="3em">Careers</Title>
      <Flex flexWrap="wrap">
        <Box width={[1, 2/3]} pr={[0, '1em']}>
          <SubTitle maxSize="1.5em" minSize="1.25em">Do you want to make the global economy more inclusive?</SubTitle>
          <Paragraph>If the answer is <strong>yes</strong>, then you should consider a career at Bidali.</Paragraph>
          <Paragraph>We&apos;re a team of builders, thinkers and dreamers - who love what we do. Using blockchain technology we’re building a platform that allows people to transact in a more open, secure, and efficient way.</Paragraph>
          <Paragraph>If you are passionate about using technology to empower others to make a meaningful impact in their own lives, then you&apos;ve found the right place.</Paragraph>
        </Box>
        <RightColumn width={[1, 1/3]} pl={[0, '1em']}>
          <Image height={366} src="/images/careers.jpg" alt="Two employees collaborating with their laptops" width={550} />
        </RightColumn>
      </Flex>
    </Section>
  );
};

export default Openings;
